import type React from "react";
import "./StatusBanner.css";
import { DatabaseZap, Info } from "lucide-react";
import { useStats } from "../hooks/useStats";

export const StatusBanner: React.FC = () => {
	const { statsRequest, healthRequest } = useStats();

	const isError = healthRequest.status === "error";
	const health =
		healthRequest.status === "success" ? healthRequest.data : undefined;
	const hasStaleData = statsRequest.status === "success" && !!statsRequest.data;

	// If the system is OK and there's no fetch error, show nothing
	if (!isError && (!health || health.status === "OK")) return null;

	const isDbDown = isError || (health && health.services.database === "DOWN");

	return (
		<div className="status-banner">
			<div className="status-banner-content">
				{isDbDown ? (
					<DatabaseZap size={16} className="status-banner-icon" />
				) : (
					<Info size={16} className="status-banner-icon" />
				)}
				<div className="status-banner-text">
					<strong>System Status: Degraded</strong>
					<span>
						{isDbDown
							? hasStaleData
								? "The database is temporarily offline. Showing cached content from your last visit."
								: "The database is temporarily offline. Some content may be unavailable."
							: "Some services are experiencing issues. We're working on it."}
					</span>
				</div>
			</div>
		</div>
	);
};
